import { render, staticRenderFns } from "./AtomTitle.vue?vue&type=template&id=6724ed2d&"
import script from "./AtomTitle.vue?vue&type=script&lang=js&"
export * from "./AtomTitle.vue?vue&type=script&lang=js&"
import style0 from "./AtomTitle.vue?vue&type=style&index=0&id=6724ed2d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports